module.exports = __webpack_public_path__ + "img/ico_menual04_on.0ea684ed.svg";